import { Theme } from '@mui/material';

import TAGSvgIcon from '@/components/TAGSvgIcon';

import { mapPinTextStyles } from './ModernGoogleMap.styles';

export const getMarkerSimpleIcon = (theme: Theme, currentState?: 'light' | 'bold' | 'normal', iconText?: string) => {
	let fill: string | undefined;
	let stroke: string | undefined;
	let strokeWidth: number | undefined;
	let size = 34;

	switch (currentState) {
		case 'light':
			fill = theme?.palette?.primary?.lightest ?? theme?.palette?.primary?.light;
			stroke = theme?.palette?.primary?.main;
			strokeWidth = 1;
			break;
		case 'bold':
			fill = theme?.palette?.primary?.light;
			stroke = theme?.palette?.primary?.lightest ?? theme?.palette?.primary?.main;
			strokeWidth = 2;
			size = 36;
			break;
		case 'normal':
		default:
			fill = theme?.palette?.primary?.main;
			stroke = theme?.palette?.primary?.lightest ?? theme?.palette?.primary?.light;
			strokeWidth = 2;
	}

	return (
		<TAGSvgIcon
			icon={'MapPinSimple'}
			size={size}
			width={34}
			height={34}
			viewBox="0 0 32 32"
			fill={fill}
			stroke={stroke}
			strokeWidth={strokeWidth}
			iconText={iconText}
			textStyles={mapPinTextStyles(theme)}
		/>
	);
};

export const getModernIconType = (isCurrentSelectedFacility?: boolean, isComingSoon?: boolean) => {
	const currentFacilityIcon = isCurrentSelectedFacility ? 'bold' : 'normal';
	const iconType = isComingSoon ? 'light' : currentFacilityIcon;
	return iconType;
};
